<template>
  <div>
    <h3 class="menu" @click="()=>goToPage('/paper/upload')" style="cursor: pointer">
      <FilePdfOutlined/>
      <span> 新阅读</span>
    </h3>
    <h3 class="menu" @click="()=>goToPage('/recent')">
      <ClockCircleOutlined/> 最近阅读
    </h3>
    <h3 class="menu" v-if="account">
      <span @click="()=>goToPage('/account/')">
      <UserOutlined/> 个人中心
    </span>
      <span @click="()=>handleMenuClick({key: 'logout'})" style="float: right">
        <LogoutOutlined/>
      </span>
    </h3>
    <h3 class="menu" v-else @click="()=>goToPage('/login/')">
        <UserOutlined/> 登录/注册
    </h3>
  </div>

</template>

<script setup>
  import { ref, onBeforeUnmount } from 'vue';
  import {getAccount, goToLogin} from "@/utils/llm.tools";
  import {
    UserOutlined, FilePdfOutlined,
    ClockCircleOutlined, LogoutOutlined
  } from '@ant-design/icons-vue';

  // import {get_user} from './utils/api';
  // 响应式逻辑
  // 响应式逻辑
  const screenWidth = ref(window.innerWidth);
  const drawerVisible = ref(true);

  const updateScreenWidth = () => {
    screenWidth.value = window.innerWidth;
  };


  onBeforeUnmount(() => {
    window.removeEventListener('resize', updateScreenWidth);
  });

  let account = getAccount();


  onBeforeUnmount(() => {
    window.removeEventListener('resize', updateScreenWidth);
  });

  // 菜单数据
  // 菜单点击处理
  const handleMenuClick = ({ key }) => {
    console.log('Menu clicked:', key);
    if(key === 'Login') {
      window.location.href = '/login'
    }
    else if(key === 'logout') {
      localStorage.clear();
      window.location.reload();
    }
    else window.location.href = '/' + key;
    if (screenWidth.value < 768) {
      drawerVisible.value = false;
    }
  };
  const goToPage = (url)=>{
    if(account) window.location.href = url;
    else goToLogin();
  }
</script>
<style scoped>
  /*@import url('./main.css');*/
  .menu {
    padding: 0 20px;
    margin-top: 20px;
    background: #FFF;
    border-radius: 8px;
    line-height: 40px;
  }
  #components-layout-demo-custom-trigger .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
  }

  #components-layout-demo-custom-trigger .trigger:hover {
    color: #1890ff;
  }

  #components-layout-demo-custom-trigger .logo {
    height: 32px;
    background: rgba(255, 255, 255, 0.3);
    margin: 16px;
  }

  .site-layout .site-layout-background {
    background: #fff;
  }
  .header {
    /*display: flex;*/
    justify-content: space-between;
    padding: 0 20px;
    /*background: #fff;*/
  }

  .mobile-trigger {
    /*color: white;*/
    font-size: 18px;
    cursor: pointer;
    padding: 0 12px;
    color: #fff;
  }

  @media (max-width: 767px) {
    .desktop-menu {
      display: none;
    }
    .header{
      /*background: #1F4E79;*/
    }
  }
  .paper-layout-content{
    margin: 24px 16px; padding: 24px; background: #fff; min-height: 280px
  }
  @media (min-width: 768px) {

    .header{
      background: #fff;
      border-bottom: 1px solid rgba(0,0, 0, 0.085);
    }
    .mobile-trigger {
      display: none;
    }
  }
  /* 当视口宽度小于 600px 时 */
  @media (max-width: 480px) {
    .paper-layout-content{
      margin: 0;
      padding: 10px;
      background: #F6F3F6
    }
  }
</style>
